import { getSortedCountries } from '../../helper/PhoneNumber';
import Grid from '@mui/material/Unstable_Grid2';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

import '../../style/SignupForm.css';

const PhoneNumberField = ( {
    handleChangeCode,
    handleChangePhone,
    errors,
    placeholder
} ) => {
    const codeItems = getSortedCountries();

    const { t } = useTranslation();

    const phoneInputProps = { maxLength: 24 };

    return (
        <Grid xs={ 12 } sm={ 12 } md={ 6 } lg={ 6 } className="form-input">
            <FormControl style={{ display: 'flex', flexDirection: 'row' }}>
                <InputLabel id={ `country-codes-select`}>{ t( 'country-code-label' ) }</InputLabel>
                <Select
                    style={{ maxHeight: '40px' }}
                    id='country-codes'
                    required
                    size="small"
                    name='dialCode'
                    labelId={ `country-codes-select` }
                    label={ t( 'country-code-label' ) }
                    onChange={ handleChangeCode }
                    onBlur={ handleChangeCode }
                    defaultValue='CA'
                >
                    { codeItems.map((item) => (
                        <MenuItem
                            key={ item.name }
                            value={ item.code }
                        >
                            <div className="country-code-container">
                                <img className="code-flag"
                                    src={require(`../../assets/country-flags/${item.flag}`)}
                                    alt={`Flag of ${item.flag}`} style={{ objectFit: 'contain' }} loading='lazy' width="24" height="22"
                                />

                                <p>{ `${item.code} (${item.dialCode})` }</p>
                            </div>
                        </MenuItem>
                        ))
                    }
                </Select>

                <TextField
                    id='phone-number-input'
                    required
                    fullWidth
                    size="small"
                    name="phoneNumber"
                    label={ t( "phone_number" ) }
                    type="tel"
                    inputProps={ phoneInputProps }
                    onChange={ handleChangePhone }
                    onBlur={ handleChangePhone }
                    errors={ errors }
                    placeholder={ placeholder }
                    { ...( errors && {
                        error: true,
                        helperText: errors,
                    } ) }
                />
            </FormControl>
        </Grid>
    );
}

export default PhoneNumberField;